import type { FC, PropsWithChildren } from 'react';
import React, { Suspense, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import type { RoleGuardProps } from '../RoleGuard/RoleGuard';
import RoleGuard from '../RoleGuard/RoleGuard';
import LoaderContainer from '../LoaderContainer/LoaderContainer';

export interface ElementWrapperProps extends RoleGuardProps {
  strict?: boolean,
  noExport?: boolean,
}

const ElementWrapper: FC<PropsWithChildren<ElementWrapperProps>> = ({
  children,
  roles,
  strict,
  additionalRequiredRoles,
  noExport = false,
}) => {
  const navigate = useNavigate();
  const isExportMode = process.env.MARKET === 'export';

  useEffect(() => {
    if (isExportMode && noExport) {
      navigate('/admin');
    }
  }, []);

  return (
    <Suspense fallback={<LoaderContainer loading={true} />}>
      <RoleGuard roles={roles} strict={strict} additionalRequiredRoles={additionalRequiredRoles}>
        {children}
      </RoleGuard>
    </Suspense>
  );
};

export default ElementWrapper;
